import React, { useContext } from 'react';
import Button from '@mui/material/Button';
import { ThemeContext } from 'styled-components';

const ButtonOutlined = ({ 
    type = 'button',
    children,
    color,
    borderColor,
    textColor,
    hoverBackgroundColor,
    ...props 
}) => {
    const theme = useContext(ThemeContext);
    
    // Default to primary if no color specified
    const defaultColor = color || theme.colors.primary;
    const finalBorderColor = borderColor || defaultColor;
    const finalTextColor = textColor || defaultColor;
    const finalHoverBackground = hoverBackgroundColor || 'rgba(255, 255, 255, 0.1)';

    return (
        <Button
            type={type}
            variant="outlined"
            sx={{
                color: finalTextColor,
                borderColor: finalBorderColor,
                '&:hover': {
                    borderColor: finalBorderColor,
                    backgroundColor: finalHoverBackground,
                },
            }}
            {...props}
        >
            {children}
        </Button>
    );
};

export default ButtonOutlined;
